import { request as requester } from 'sonata-react-components';
import { getSonataSession } from 'sonata-static-storage/lib/helpers/session.helpers';

import type { SessionInterface } from 'sonata-static-storage/lib/schemas/session/session.schema';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';

export function maskUserAccess(data: { from: string; to: string }): Promise<string> {
  return requester.makeRequest(
    // @ts-ignore
    `${taptap.config.backendUrlBase}masquerade/access`,
    {
      data,
      headers: {
        appId: 'sonata',
        'sonata-origin': 'retail-api'
      },
      method: 'POST'
    }
  );
}

export function maskCustomUserAccess(selectedUserId: string): Promise<void> {
  return requester.makeRequest(
    // @ts-ignore
    `${taptap.config.backendUrlBase}customUser/${selectedUserId}`,
    {
      method: 'POST'
    }
  );
}

export function restoreMaskUser(session: SessionInterface): Promise<SessionInterface> {
  return requester.makeRequest(
    session.userFrom
      ? // @ts-ignore
        `${taptap.config.backendUrlBase}masquerade/restoreaccess`
      : // @ts-ignore
        `${taptap.config.backendUrlBase}restoreSettings`,
    {
      headers: {
        appId: 'sonata',
        'sonata-origin': 'retail-api'
      },
      method: 'POST'
    }
  );
}

export function restoreCustomUser(): Promise<SessionInterface> {
  return requester.makeRequest(
    // @ts-ignore
    `${taptap.config.backendUrlBase}restoreSettings`,
    {
      headers: {
        appId: 'sonata',
        'sonata-origin': 'retail-api'
      },
      method: 'POST'
    }
  );
}

export async function getPreferredUsers(token: Record<string, any>): Promise<UserInterface[]> {
  return requester.makeRequest(
    `${taptap.config.sonataBackendUrl}masquerade/preferredUsers/10`,
    {
      headers: {
        appId: 'sonata',
        'sonata-origin': 'retail-api'
      }
    },
    token
  );
}

export async function getSearchUsers(searchValue: string, token: Record<string, any>): Promise<UserInterface[]> {
  return requester.makeRequest(
    `${taptap.config.sonataBackendUrl}masquerade/users/${searchValue}`,
    {
      headers: {
        appId: 'sonata',
        'sonata-origin': 'retail-api'
      },
      method: 'GET'
    },
    token
  );
}

export async function getMasqueradeLogin(accessId: string): Promise<any> {
  const headers = {
    ...getSonataSession(),
    appid: 'sonata',
    'sonata-origin': 'retail-api'
  };

  return requester.makeRequest(`${taptap.config.backendUrlBase}masquerade/login/${accessId}`, {
    headers,
    method: 'GET'
  });
}
